import '../../../styles/Stand/Show.css';
import { AppForm }                     from 'components/App/AppForm';
import { withNavigation }              from 'components/App/withNavigation';
import { WithNavigationProps }         from 'components/App/withNavigation';
import React                           from 'react';
import { Button }                      from 'antd';
import { Col }                         from 'antd';
import { ApiCollection }               from 'collections/ApiCollection';
import Row                             from 'components/App/Row';
import StandLayoutListBox              from 'components/Stand/Dashboard/SandLayoutListBox';
import StandDashboardConstatsBox       from 'components/Stand/Dashboard/StandDashboardConstatsBox';
import StandDashboardHeader            from 'components/Stand/Dashboard/StandDashboardHeader';
import StandDashboardPlansBox          from 'components/Stand/Dashboard/StandDashboardPlansBox';
import StandDashboardShowBox           from 'components/Stand/Dashboard/StandDashboardShowBox';
import StandMessageListBox             from 'components/Stand/Dashboard/StandDashboardStandMessageListBox';
import { appStore }                    from 'stores/AppStore';
import { privateLayoutStore }          from 'stores/index';
import { standDashboardStore }         from 'stores/index';
import currentSession                  from 'utils/currentSession';
import StandDashboardHeaderDropdownBtn from '../components/StandDashboardHeaderDropdownBtn';
import StandDashboardDocumentsBox      from '../../../components/Stand/Dashboard/StandDashboardDocumentsBox';
import StandSecurityInstructionModel   from 'models/StandSecurityInstructionModel';
import NotificationModel               from 'models/NotificationModel';
import FormattedMessageWrapper         from 'components/App/FormattedMessageWrapper';
import StandDashboardDemandListBox     from 'components/Stand/Dashboard/StandDashboardDemandListBox';
import UserLanguagePreferenceForm      from 'forms/UserLanguagePreferenceForm';
import SecurityInstructionsForm        from 'forms/SecurityInstructionsForm';
import SendNotificationForm            from 'forms/SendNotificationForm';
import PageTitle                       from 'components/App/PageTitle';
import StandModel                      from 'models/StandModel';

class StandDashboard extends React.Component<WithNavigationProps> {
  public state: {
    dataLoading: boolean;
  } = {
      dataLoading: true,
    };

  constructor(props: WithNavigationProps) {
    super(props);

    const {
      id: standId,
    } = this.props.params;

    standDashboardStore.stand.setId(standId);
  }

  public async componentDidMount() {
    await this._fetchData();

    try {
      await privateLayoutStore.setCurrentShowId(standDashboardStore.show.id);
    } catch (error: any) {
      if (error.name === 'show_not_found') {
        this.props.navigate('/404');
      }

      if (error.name === 'get_show_unauthorized') {
        this.props.navigate('/erreur');
      }

      return;
    }

    await standDashboardStore.fetchStatusesAndTypes();

    this._setDataLoading(false);
  }

  public async componentDidUpdate(prevProps: WithNavigationProps) {
    if (prevProps.params !== this.props.params) {
      const {
        id: standId,
      } = this.props.params;

      await standDashboardStore.fetchData(standId);

      try {
        await privateLayoutStore.setCurrentShowId(standDashboardStore.show.id);
      } catch (error: any) {
        if (error.name === 'show_not_found') {
          this.props.navigate('/404');
        }

        if (error.name === 'get_show_unauthorized') {
          this.props.navigate('/erreur');
        }
      }
    }
  }

  public render() {
    const {
      id: standId,
    } = this.props.params;

    const {
      collUserStandRole,
      show,
      stand,
      virtualCollAgency,
      virtualCollDecorator,
      virtualCollExhibitor,
    } = standDashboardStore;

    const externalSync = show.get('externalSync', false);

    return (
      <>
        <div className="page-loading">
          {this.state.dataLoading && (
            <Button htmlType="button" loading>
              <FormattedMessageWrapper id="Chargement" />
            </Button>
          )}
        </div>

        <PageTitle title={<FormattedMessageWrapper id="Tableau de bord du stand" />} />

        <Row>
          <Col span={24}>
            <StandDashboardHeader
              agencyVirtualCollection={virtualCollAgency}
              decoratorVirtualCollection={virtualCollDecorator}
              dropdownBtn={
                <StandDashboardHeaderDropdownBtn
                  agencyCollection={virtualCollAgency}
                  decoratorCollection={virtualCollDecorator}
                  exhibitorCollection={virtualCollExhibitor}
                  externalSync={externalSync}
                  fetchStandistsWithRoles={() => standDashboardStore.fetchRoleCollectionAndStandistsData(standId)}
                  setConfirmationNotifyVisible={(value: boolean) => {
                    if (value) {
                      AppForm.open(SendNotificationForm, {
                        externalSync: !!externalSync,
                        model: new NotificationModel(),
                        selectedRows: [stand],
                        standCollectionFull: new ApiCollection(StandModel),
                      }, {
                        okText: <FormattedMessageWrapper id="Envoyer" />,
                        title: <FormattedMessageWrapper id="Envoyer une notification" />,
                      });
                    }
                  }}
                  stand={stand}
                  userStandRoleCollection={collUserStandRole}
                />
              }
              exhibitorVirtualCollection={virtualCollExhibitor}
              externalSync={externalSync}
              fetchStandistsWithRoles={() => standDashboardStore.fetchRoleCollectionAndStandistsData(standId)}
              isLoading={
                stand.isLoading ||
                virtualCollAgency.isLoading ||
                virtualCollDecorator.isLoading ||
                virtualCollExhibitor.isLoading
              }
              stand={stand}
              userStandRoleCollection={collUserStandRole}
            />
          </Col>

          <Col span={24}>
            <StandDashboardShowBox
              isLoading={this.state.dataLoading}
            />
          </Col>

          <Col span={14}>
            <StandMessageListBox
              fetchParentData={this._fetchData}
            />
          </Col>

          <Col span={10}>
            <Row>
              <Col span={24}>
                <StandDashboardPlansBox
                  fetchParentData={() => standDashboardStore.fetchMessages(standId)}
                />
              </Col>

              <Col span={24}>
                <StandDashboardDocumentsBox />
              </Col>

              {show.standDocumentsOption && (
                <Col span={24}>
                  <StandDashboardDemandListBox
                    setDataLoading={this._setDataLoading}
                  />
                </Col>
              )}

              <Col span={24}>
                <StandLayoutListBox />
              </Col>

              <Col span={24}>
                <StandDashboardConstatsBox
                  fetchParentData={this._fetchData}
                  setDataLoading={this._setDataLoading}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </>
    );
  }

  private _fetchData = async () => {
    this.setState({ dataLoading: true });

    const { id } = this.props.params;

    const {
      stand,
    } = standDashboardStore;

    try {
      await standDashboardStore.fetchData(id);
    } catch (error: any) {
      if (error.name === 'stand_not_found') {
        this.props.navigate('/404');
      }

      if (error.name === 'get_stand_unauthorized') {
        this.props.navigate('/erreur');
      }

      return;
    }

    currentSession.showId = stand.showId;

    try {
      await privateLayoutStore.setCurrentShowId(stand.showId);
    } catch (error: any) {
      if (error.name === 'show_not_found') {
        this.props.navigate('/404');
      }

      if (error.name === 'get_show_unauthorized') {
        this.props.navigate('/erreur');
      }

      return;
    }

    // await for dataLoading at the end
    await this._standSeen();

    if (!currentSession.user.user_informations.language_preference) {
      AppForm.open(UserLanguagePreferenceForm, {
        onSuccess: (locale: string) => {
          appStore.switchLanguage(locale);

          if (this._shouldShowSecurityInstructions) {
            this._openStandSecurityInstructionsFormModal();
          }
        }
      }, {
        okText: <FormattedMessageWrapper id="Enregistrer" />,
        title: <FormattedMessageWrapper id="Choisissez une langue" />,
      });
    } else if (this._shouldShowSecurityInstructions) {
      this._openStandSecurityInstructionsFormModal();
    }

    this.setState({ dataLoading: false });
  };

  private _openStandSecurityInstructionsFormModal = () => {
    const {
      collDocument,
      show,
      stand,
    } = standDashboardStore;

    AppForm.open(SecurityInstructionsForm, {
      onSuccess: () => {
        collDocument.list();
      },
      model: new StandSecurityInstructionModel(),
      setLoading: (loading: boolean) => this.setState({ dataLoading: loading }),
      show,
      stand,
    }, {
      closable: false,
      okText: <FormattedMessageWrapper id="Enregistrer" />,
      title: <FormattedMessageWrapper id="NOTICE SPS EXPOSANT" />,
    });
  }

  private _setDataLoading = (loading: boolean) => {
    this.setState({ dataLoading: loading });
  };

  private get _shouldShowSecurityInstructions(): boolean {
    const { show, stand } = standDashboardStore;
    return (
      currentSession.isStandist
      && show.securityInstructionsOption
      && !stand.standSecurityInstruction
    );
  }

  private _standSeen = async () => {
    const {
      stand,
    } = standDashboardStore;

    if (currentSession.isAdminOrSupport && stand?.unSeen) {
      await stand.patch({ unSeen: false });
    }
  };
}

const StandDashboardWithNavigation = withNavigation(StandDashboard);

export default StandDashboardWithNavigation;
